export default __webpack_public_path__ + "play-icon.svg";